/* eslint-disable @typescript-eslint/no-inferrable-types,@typescript-eslint/default-param-last */
import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { decorateFontSizeSwitcher } from './decorateFontSizeSwitcher';
import { renderElementFontSizeSwitcher } from './renderElementFontSizeSwitcher';
import { renderLeafFontSizeSwitcher } from './renderLeafFontSizeSwitcher';
import { FontSizeModeEnum } from './types';

export const getNextFontSizeMode = (fontSizeMode: FontSizeModeEnum) => {
  switch (fontSizeMode) {
    case FontSizeModeEnum.DEFAULT: {
      return FontSizeModeEnum.LARGE;
    }
    case FontSizeModeEnum.LARGE: {
      return FontSizeModeEnum.EXTRA_LARGE;
    }
    case FontSizeModeEnum.EXTRA_LARGE: {
      return FontSizeModeEnum.DEFAULT;
    }
    default:
  }
  throw new Error(`Unknown fontSizeMode ${fontSizeMode}`);
};

export const FontSizeSwitcherPlugin = (fontSizeMode: FontSizeModeEnum, isHideParagraphIndex: boolean = false): SlatePlugin => ({
  decorate: decorateFontSizeSwitcher(fontSizeMode),
  renderLeaf: renderLeafFontSizeSwitcher(),
  renderElement: renderElementFontSizeSwitcher(fontSizeMode, isHideParagraphIndex),
});
